export const Messages = {
  insufficientPermissions: 'Insufficient access permissions.',
  featureDisabled: 'Advisors feature is disabled.',
  check: 'Check ',
  pmmSettings: 'PMM Settings.',
};
